// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2OVit","balanceDisclaimer":"posDashboard_balanceDisclaimer__e291v"};